import { Box } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { colorPalette, colorTokens } from '../../../../../shared/components/variables';

export const EventContainer = styled(Box)`
  display: flex;
  align-items: center;
  align-content: center;
  gap: 6.462px;
  align-self: stretch;
  flex-wrap: wrap;
`;

export const InnerCard = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 12px;
  margin: 10px 0 10px;
  gap: 12px;
  width: 100%;

  border-radius: 12px;
  border: 1.38px solid ${colorTokens.border.main};
  background: #f7fafc;
`;

export const DotIcon = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${colorPalette.neutralVariant80};
`;
